import { render, staticRenderFns } from "./LiveDash.vue?vue&type=template&id=2680339b"
import script from "./LiveDash.vue?vue&type=script&lang=js"
export * from "./LiveDash.vue?vue&type=script&lang=js"
import style0 from "./LiveDash.vue?vue&type=style&index=0&id=2680339b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports